import { createSelector } from 'reselect'
import { IStore } from 'apps/carrier/utils/reducers'

const selectHeaderActions = (state: IStore) => state

export const headerActionsSelector = createSelector(
  selectHeaderActions,
  ({ carrier: { actionInProgress, carrierDetails }, carrierDocumentsCheckLists }) => ({
    id: carrierDetails?.id,
    inProgress: actionInProgress,
    carrierDocumentsCheckLists,
    carrierActivated: carrierDetails?.state !== 'activated',
    existsInNetsuite: Boolean(carrierDetails?.netsuiteId),
  })
)
